import React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { useToggle } from 'react-use';
import Input from 'shared/component/inputFields';
import { formatDate } from 'shared/helpers/utils';
import CloseIcon from 'shared/assets/images/svg/close_form.svg'
import PrintIcon from 'shared/assets/images/svg/print.svg'
import SendIcon from 'shared/assets/images/svg/send_email.svg'

const ViewTicket = ({ show,onHide,ticketData, name }) => {
    return (
        <div>
            <React.Fragment >
                <SwipeableDrawer
                    anchor='right'
                    open={show}
                    onClose={onHide}
                >
                    <Box
                        // sx={{ width: 764 }}
                        role="presentation"
                        onClick={onHide}
                        className="viewTicketPopup"
                        
                    >
                        <div className='row'>
                            <div className='col-12'>
                            <div className='drawerHeader'>
                            <div className='info'>
                                <h2>Ticket</h2>
                            </div>
                            <div className='action'>
                                <img src={SendIcon} alt="SendIcon"/>
                                <img src={PrintIcon} alt="PrintIcon"/>
                                <img src={CloseIcon} alt="close" onClose={onHide}/>
                            </div>
                        </div>
                            </div>
                        </div>
                        <div className='drawerContent'>
                            <h1 className='drawerTitle'>Info</h1>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    Customer Name  <small className="star-require">*</small>
                                </label>
                                <div className='col-lg-8'>
                                    <div className='row'>
                                        <div className="col-lg-9">
                                            <Input type="text" require readonly value={ticketData?.accountName} />
                                        </div>
                                        <div className="col-lg-3">
                                            <Input type="text" require readonly value={ticketData?.accountNumber} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    GPS
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.gdsProvider} />
                                </div>
                            </div>


                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    Ticket No. / PNR   <small className="star-require">*</small>
                                </label>
                                <div className="col-lg-8">
                                    <div className='row'>
                                        <div className='col-lg-6'>
                                            <Input type="text" require readonly value={ticketData?.ticketNumber}/>
                                        </div>
                                        <div className='col-lg-6'>
                                            <Input type="text" require readonly  value={ticketData?.pnr}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    Booked By  <small className="star-require">*</small>
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.usercode}/>
                                </div>
                            </div>
                            { /*  */}

                            <h1 className='drawerTitle'>PAX</h1>

                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    PAX Name *  <small className="star-require">*</small>
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly  value={ticketData?.paxName}/>
                                </div>
                            </div>

                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    Destination / Direction *  <small className="star-require">*</small>
                                </label>
                                <div className="col-lg-8">
                                    <div className='row'>
                                        <div className='col-lg-6'>
                                            <Input type="text" require readonly />
                                        </div>
                                        <div className='col-lg-6'>
                                            <Input type="text" require readonly  value={ticketData?.direction}/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    Segments <small className="star-require">*</small>
                                </label>
                                <div className="col-lg-5">
                                    <Input type="text" require readonly value={ticketData?.segmentCount}/>
                                </div>
                            </div>

                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    Issue Date  <small className="star-require">*</small>
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={formatDate(ticketData?.issueDate)} />
                                </div>
                            </div>

                            {/*  */}
                            <h1 className='drawerTitle'>Ticket</h1>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    Basic Fare  <small className="star-require">*</small>
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.basicFare} />
                                </div>
                            </div>

                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    total taxes
                                </label>
                                <div className="col-lg-8">
                                    <div className='row'>
                                        <div className='col-lg-3'>
                                            <Input type="text" require readonly />
                                        </div>
                                        <div className='col-lg-9'>
                                            <Input type="text" require readonly  value={ticketData?.ticketTaxes} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    commission
                                </label>
                                <div className="col-lg-8">
                                    <div className='row'>
                                        <div className='col-lg-3'>
                                            <Input type="text" require readonly value={ticketData?.commisionVAT?.toFixed?.(2)} />
                                        </div>
                                        <div className='col-lg-9'>
                                            <Input type="text" require readonly value={ticketData?.commision?.toFixed?.(2)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    airline commission
                                </label>
                                <div className="col-lg-8">
                                    <div className='row'>
                                        <div className='col-lg-3'>
                                            <Input type="text" require readonly value={ticketData?.airLineCommVAT?.toFixed?.(2)} />
                                        </div>
                                        <div className='col-lg-9'>
                                            <Input type="text" require readonly value={ticketData?.airLineComm?.toFixed?.(2)} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h1 className='drawerTitle'>others</h1>
                            {/*<div className="form-group form-div mt-0 row g-3 align-items-center">*/}
                            {/*    <label className="col-lg-4 col-form-label ">*/}
                            {/*        discount*/}
                            {/*    </label>*/}
                            {/*    <div className="col-lg-8">*/}
                            {/*        <div className='row'>*/}
                            {/*            <div className='col-lg-3'>*/}
                            {/*                <Input type="text" require readonly />*/}
                            {/*            </div>*/}
                            {/*            <div className='col-lg-9'>*/}
                            {/*                <Input type="text" require readonly />*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    cancel Fees
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.feez} />
                                </div>
                            </div>
                            {/*  */}
                            <h1 className='drawerTitle'>trip info</h1>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    airline code <small className='star-require'>*</small>
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.airLineCode}  />
                                </div>
                            </div>
                            {/*<div className="form-group form-div mt-0 row g-3 align-items-center">*/}
                            {/*    <label className="col-lg-4 col-form-label ">*/}
                            {/*        airline company <small className='star-require'>*</small>*/}
                            {/*    </label>*/}
                            {/*    <div className="col-lg-8">*/}
                            {/*        <Input type="text" require readonly />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    iata no.
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.vendorName} />
                                </div>
                            </div>

                            <h1 className='drawerTitle'>Location</h1>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    departure airport <small className='star-require'>*</small>
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.departCity}  />
                                </div>
                            </div>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    arrival airport <small className='star-require'>*</small>
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.arriveCity} />
                                </div>
                            </div>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    routes
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.routes} />
                                </div>
                            </div>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    departure date
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.departDate}  />
                                </div>
                            </div>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    arrival date
                                </label>
                               <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.arriveDate} />
                                </div>
                            </div>
                            {/*  */}
                            <h1 className='drawerTitle'>contact data</h1>
                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    PAX Phone No. <small className='star-require'>*</small>
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.passengerPhone} />
                                </div>
                            </div>

                            <div className="form-group form-div mt-0 row g-3 align-items-center">
                                <label className="col-lg-4 col-form-label ">
                                    PAX E-Mail
                                </label>
                                <div className="col-lg-8">
                                    <Input type="text" require readonly value={ticketData?.passengerMail} />
                                </div>
                            </div>

                        </div>
                    </Box>
                </SwipeableDrawer>
            </React.Fragment>

        </div>
    )
}

export default ViewTicket